import React, { Component } from 'react';
import { Plus, Minus } from '../../common/icons';

class QuantityControls extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  componentDidMount() {
    const { color } = this.props;

    if (color) {
      if (this.refs.titleRef) {
        this.refs.titleRef.style.setProperty('color', color);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { color } = this.props;
    
    if (prevProps.color !== color) {
      if (color) {
        if (this.refs.titleRef) {
          this.refs.titleRef.style.setProperty('color', color);
        }
      }
    }
  }

  render() {
    return (
      <div className="quantity-container">
        <h4 ref="titleRef">Quantity</h4>
        <div className="quantity-counter-container">
          <div className="quantity-counter-button" onClick={() => this.props.handleQuantityCount('neg')}>
            <Minus />
          </div>
          <input type='text' className="quantity-counter-input" name="quantity_counter" value={this.props.quantity_counter} onChange={(e) => this.props.handleQuantityInput(e)} />
          <div className="quantity-counter-button" onClick={() => this.props.handleQuantityCount('pos')}>
            <Plus />
          </div>
        </div>
      </div>
    );
  }
}

export default QuantityControls;



// WEBPACK FOOTER //
// ./src/components/new-order/card/quantity-controls.jsx